import { Component, Input, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { EmbryoService } from "./../../Services/Embryo.service";
import { Router } from "@angular/router";
import { ReactivityService } from "../../Services/reactivity.service";
import { Subscription } from "rxjs";
import { StaticPagesService } from "src/app/Services/static-pages.service";

@Component({
    selector: "app-notification-list-menu",
    templateUrl: "./notification-list-menu.component.html",
    styleUrls: ["./notification-list-menu.component.scss"],
})
export class NotificationListMenuComponent implements OnInit, OnDestroy {
    @Input() lang: any;
    @ViewChild("menuTrigger", { static: false }) menuTrigger: any;
    toggleLoading: boolean = false;
    isAuthUser: any;
    user: any;
    enteredMenu: boolean = false;
    unreadCount: number = 0;
    notificationsList: Array<any> = [];
    subscription: Subscription;
    environmentVariables: any;
    headerIconsColor:any;
     changeIconFill:boolean = true;
    constructor(
        private embryoService: EmbryoService,
        private reactivityService: ReactivityService,
        private pagesService: StaticPagesService,
        private router: Router
    ) {
        this.pagesService.getenvConfig().subscribe((res: any) => {
            this.environmentVariables = res;
             this.headerIconsColor =   this.environmentVariables.HEADER_ICONS_FILL_COLOR;
        });
        this.subscription = this.reactivityService.storeObserver$.subscribe(
            (data: any) => {
                if (data && data.loggedOutUser) {
                    this.notificationsList = [];
                    this.unreadCount = 0;
                }
            }
        );
    }

    ngOnInit() {
        this.isAuthUser = JSON.parse(
            <string>localStorage.getItem("auth_user_crocs")
        );
        this.embryoService.notificationsListSub.subscribe((res: any) => {
            if (res) {
                this.notificationsList = res ? res.notifications : [];
                this.unreadCount = res ? res.unreadNotifications : 0;
            }
        });
    }

    ngOnDestroy() {
        if (this.subscription) this.subscription.unsubscribe();
    }

    checkUserGuest() {
        this.user = JSON.parse(<string>localStorage.getItem("auth_user_crocs"));
        !this.user
            ? this.router.navigate(["/" + this.lang + "/session/signin"], {
                  queryParams: { returnUrl: "/notifications" },
              })
            : this.router.navigate(["/" + this.lang + "/notifications"]);

        /* Reset Counter */
        this.notificationsList.forEach((item) => (item.read = 1));
        this.embryoService.notificationsListSub.next({
            notifications: this.notificationsList,
            unreadNotifications: 0,
        });
    }

    // goToDetails(data: any) {
    //       console.log(data);
          
    //     if (data.type == 5) {
    //         this.router.navigate([
    //             "/" +
    //                 this.lang +
    //                 (!this.user || this.user?.is_guest
    //                     ? `/orders/order-history/${data.item_id}`
    //                     : `/account/order-history/${data.item_id}`),
    //         ]);
    //     } 
    //     else if (data.type == 2) {
    //             this.router.navigate(["/" + this.lang + "/" + data?.slug])
    //     }
    // }
     goToDetails(data: any) {
      console.log('11');
      
        const { item_id, title, item_link } = data;
        const queryParams: any = {};
        var link = false;
        switch (data?.type) {
            case null:
                return;
            case 1:
                break;
            case 2:
               this.router.navigate(["/" + this.lang + "/" + data?.slug])
                break;
            case 3:
                queryParams.brand_id = item_id;
                link = true;
                break;
            case 4:
                    this.router.navigate([this.lang + '/product/' + 
                        data.item_slug ]);
                break;
            case 5:
                this.router.navigate([
                    "/" +
                        this.lang +
                        (!this.user || this.user?.is_guest
                            ? `/orders/order-history/${item_id}`
                            : `/account/order-history/${item_id}`),
                ]);
                break;
            case 6:
                        this.router.navigate([this.lang + '/product/' + 
                        data.category_slug +'/' + data.group_slug + '/' + data.item_slug]);
                break;
            case 7:
                queryParams.list_ids = item_id;
                link = true;
                break;
            case 14:
                       this.environmentVariables?.ENABLE_CATEGORY_VIEW ? 
                       this.router.navigate([this.lang + "/category/" + data.category_slug +'/' + data.item_slug]) : 
                        this.router.navigate([this.lang + '/product/' + data.category_slug +'/' + data.item_slug]);
                    
                break;
        }
        link
            ? this.router.navigate(["/" + this.lang + "/products"], {
                  queryParams: queryParams,
              })
            : null;
    }

    toggleMenu(event: any, open: any) {
        if (open) {
            event.stopPropagation();
            this.enteredMenu = false;
            this.menuTrigger.openMenu();
        } else {
            setTimeout(() => {
                if (!this.enteredMenu) {
                    this.menuTrigger.closeMenu();
                }
            }, 150);
        }
    }

    closeMatMenu() {
        this.enteredMenu = false;
        this.menuTrigger.closeMenu();
    }
}
